import { useEffect, useState } from 'react';
import { api } from './api';

/* Куда ушёл код входа: RedSMS шлёт каскадом Telegram → звонок → SMS (api/src/lib/sms.ts).
   Экран ввода кода опрашивает сервер, пока код не дойдёт, и подсказывает, где его искать. */
export type CodeChannel = 'tg' | 'call' | 'sms' | null;
const DONE = new Set(['delivered', 'read', 'reply']);

/** sentAt — когда запросили код (меняется при повторной отправке — опрос начинается заново) */
export function useCodeChannel(phone: string, sentAt: number): { channel: CodeChannel; status: string } {
  const [st, setSt] = useState<{ channel: CodeChannel; status: string }>({ channel: null, status: '' });
  useEffect(() => {
    if (!phone || !sentAt) return;
    setSt({ channel: null, status: '' });
    let stop = false;
    let t: ReturnType<typeof setTimeout>;
    const tick = async () => {
      const r = await api.auth.codeStatus.query({ phone }).catch(() => null);
      if (stop) return;
      if (r) setSt({ channel: r.channel, status: r.status });
      /* Дошло SMS или кончилось время — хватит */
      if ((r?.channel === 'sms' && DONE.has(r.status)) || Date.now() - sentAt > 5 * 60_000) return;
      t = setTimeout(tick, 3000);
    };
    t = setTimeout(tick, 1500);
    return () => {
      stop = true;
      clearTimeout(t);
    };
  }, [phone, sentAt]);
  return st;
}

/** Подсказка под полем кода */
export function codeHint({ channel, status }: { channel: CodeChannel; status: string }): string {
  if (channel === 'tg') return DONE.has(status) ? 'Код в Telegram — в чате «Verification Codes»' : 'Отправляем код в Telegram…';
  if (channel === 'call') return 'Вам звонят — введите последние 4 цифры номера. Отвечать не нужно';
  if (channel === 'sms') return 'Код отправлен в SMS';
  return 'Код придёт в Telegram, если он есть на этом номере, иначе — позвоним или пришлём SMS';
}
